import i18next from 'i18next';

i18next.addResources('es_CL', 'Home', {
  homeTitle: 'KDS - Home',
  homeDescription: 'KDS - Kitchen Home',
  newPosRejectedOrder: 'Nueva orden rechazada por el POS {{orderId}}',
  deliveryReassigned: 'El delivery de la orden {{orderId}} ha sido reasignado correctamente.'
});

i18next.addResources('es_CR', 'Home', {
  homeTitle: 'KDS - Home',
  homeDescription: 'KDS - Kitchen Home',
  newPosRejectedOrder: 'Nueva orden rechazada por el POS {{orderId}}'
});
